export default __webpack_public_path__ + "static/benefitImage4-7a099543cbb2f14d92be85a7c1aeccd0.webp";